"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Accordion = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var button_1 = require("../../elements/button/button");
var button_type_1 = require("../../elements/button/button-type");
var icon_1 = require("../../elements/icon/icon");
var icon_type_1 = require("../../elements/icon/icon-type");
var drag_container_1 = require("../drag-container/drag-container");
var draggable_box_1 = require("../drag-container/draggable-box/draggable-box");
var accordion_style_1 = require("./accordion-style");
function Accordion(props) {
    var items = props.items, _a = props.transitionTimeout, transitionTimeout = _a === void 0 ? 500 : _a, _b = props.dragId, dragId = _b === void 0 ? '' : _b, noDraggable = props.noDraggable, onDragItemEnd = props.onDragItemEnd, restProps = __rest(props, ["items", "transitionTimeout", "dragId", "noDraggable", "onDragItemEnd"]);
    return ((0, jsx_runtime_1.jsx)(accordion_style_1.StyledAccordion, __assign({}, restProps, { transition: true, transitionTimeout: transitionTimeout, children: (0, jsx_runtime_1.jsx)(drag_container_1.DragContainer, { droppableId: dragId, onDragEnd: function (result) {
                onDragItemEnd === null || onDragItemEnd === void 0 ? void 0 : onDragItemEnd(result);
            }, notDraggable: noDraggable, children: (0, jsx_runtime_1.jsx)("div", { children: items.map(function (item, index) {
                    var header = item.header, content = item.content, buttons = item.buttons, _a = item.initialEntered, initialEntered = _a === void 0 ? false : _a;
                    return ((0, jsx_runtime_1.jsx)(draggable_box_1.DraggableBox, { draggableId: "".concat(dragId, "-").concat(index), index: index, notDraggable: noDraggable, children: (0, jsx_runtime_1.jsxs)("div", { className: "draggable-container", children: [buttons ? ((0, jsx_runtime_1.jsx)(accordion_style_1.StyledAccordionButtons, { children: buttons.map(function (button, buttonIndex) {
                                        return ((0, react_1.createElement)(button_1.Button, __assign({}, button, { size: button_type_1.ButtonSize.SMALL, key: buttonIndex, onClick: function (event) {
                                                var _a;
                                                (_a = button.onClick) === null || _a === void 0 ? void 0 : _a.call(button, { itemIndex: index, item: item, event: event });
                                            } })));
                                    }) })) : null, (0, jsx_runtime_1.jsx)(accordion_style_1.StyledAccordionItem, { initialEntered: initialEntered, transitionTimeout: transitionTimeout / 1000, header: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [header, " ", (0, jsx_runtime_1.jsx)(icon_1.Icon, { iconName: icon_type_1.IconName.CHEVRON_DOWN, className: "chevron-down" })] }), children: content })] }) }, index));
                }) }) }) })));
}
exports.Accordion = Accordion;
